import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  LabelList,
} from "recharts";

const HorizontalBarChart = ({ theme, data , radius=true, alignment=true, height=300, noSign=false}) => {
  const formatter = (tickValue) => {
    if (!tickValue || noSign) return tickValue;
    return `$${tickValue.toLocaleString()}`;
  };
  console.log(data,"horizontal" )
  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart
        data={data}
        layout="vertical"
        margin={{ top: 20, right: 30, left: 50, bottom: 20 }}
      >
        <XAxis
          type="number"
          axisLine={{ stroke: "none" }}
          tick={{
            fill: theme === "dark" ? "#f8ffef" : "rgb(102, 102, 102)",
            fontWeight: 600,
            fontSize: 20,
            angle:  alignment?-45:0,
            dy: - alignment?20:0,
            textAnchor: "end"
          }}
          tickLine={false}
          tickFormatter={formatter}
        />
        <YAxis
          type="category"
          dataKey="name"
          axisLine={{ stroke: "none" }}
          tickLine={false}
          tick={{
            fill: theme === "dark" ? "#f8ffef" : "rgb(102, 102, 102)",
            fontSize: 20,
            fontWeight: 600,
          }}
        />
        <Bar
          dataKey="value"
          fill="#8884d8"
          barSize={80}
          radius={radius? [0, 32, 32, 0]:[0,0,0,0]}
          className="bar-element-chart"
        >
          <LabelList
            dataKey="barDisplayInnerValue"
            position={radius? "insideLeft":"insideRight"}
            fill={theme === "dark" ? "#333" : "#fff"}
            style={{ fontSize: 20, fontWeight: 600 }}
            formatter={(value) => value.toLocaleString()}
               className="bar-chart-label"
            
          />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default HorizontalBarChart;
